import {
    breakCarList,
    drivingList
} from "@/api/break";
import store from '@/utils/store';

const actions = {
    // 获取用户车辆
    carList(context, isReLoad = false) {
        store.loadCacheData(context, 'carList', breakCarList, null, {
            mutationName: 'carList',
            isReLoad: isReLoad
        });
    },
    // 获取用户驾照
    drivingList(context, isReLoad = false) {
        store.loadCacheData(context, 'drivingList', drivingList, null, {
            mutationName: 'drivingList',
            isReLoad: isReLoad
        });
    }
}
export default actions